import AddIcon from '@mui/icons-material/Add';
import ChangeHistoryIcon from '@mui/icons-material/ChangeHistory';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import React, { useState } from 'react';
import { MyMLabel } from '../ui-elements/MyMLabel';

/** MyMine Version2.0 共通化に伴い新規作成
 * CustomAccordion Component
 * @param {any} param0
 * @returns
 */
const CustomAccordion = (
  {
    defaultOpen,
    menuText,
    contents,
  }) => {

  const [isAccordionOpen, setIsAccordionOpen] = useState(defaultOpen ?? false);

  return (
    <Accordion
      expanded={isAccordionOpen}
      className='custom-accordion my-0 shadow-none'
      sx={{ '&.Mui-expanded': { backgroundColor: '#E6E6E6', marginBottom: '1rem' }, borderBottom: '0.5px solid #acacac' }}
      onChange={(e, expanded) => setIsAccordionOpen(expanded)}
    >
      <AccordionSummary
        expandIcon={isAccordionOpen ? <ChangeHistoryIcon /> : <AddIcon />}>
        <MyMLabel className='fw-bold' sx={{ px: 3 }}>{menuText}</MyMLabel>
      </AccordionSummary>
      <AccordionDetails>
        {contents}
      </AccordionDetails>
    </Accordion>
  );
};
export default CustomAccordion;